<template>
  <Toast/>
  <div class="row">
    <div class="col">
      <h2 class="titre">Modification Journal</h2>
    </div>
  </div>
  <ModifierChamps ref="modifierChamps" :journal="journal" :isModifier="true"/>
  <ButtonBarJournal @sauvegarder="sauvegarder" @fermer="fermer" :isSauvegardeEnCours="isSauvegardeEnCours"/>
  <DialogConfirmation ref="dialogConfirmation"/>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue';
import ButtonBarJournal from '../../../components/dossier/Ajouter/ButtonBarJournal.vue';
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsJournal.vue';

export default {
  name: "ModifierJournal",
  components: {
    DialogConfirmation,
    ModifierChamps,
    ButtonBarJournal,
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      journal: 'journal/journal'
    }),
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Modifier Journal");
  },
  data() {
    return {
      isSauvegardeEnCours: false,
    };
  },
  methods: {
    sauvegarder() {
      this.isSauvegardeEnCours = true;
      this.$store.commit('journal/UPDATE_JOURNAL', this.$refs.modifierChamps.getJournalLocal());
      this.$store.dispatch('journal/sauvegarderJournalAction', {
        cle: this.$route.params.cle,
        site: this.$route.params.site,
      }).then((res) => {
        if (res?.data?.messages.length == 0) {
          this.$toast.add({
            severity: 'success',
            summary: 'Modifier',
            detail: 'Le journal a été modifié.',
            life: 6000
          });
          this.isSauvegardeEnCours = false;
        } else {
          this.$root.$refs.messagesComp.messagesList = res.data.messages;
          this.isSauvegardeEnCours = false;
        }
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
  beforeRouteLeave(to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.journal, this.$refs.modifierChamps.getJournalLocal());
  },
}
</script>